export default __webpack_public_path__ + "static/media/ser-reports.6b39d422.svg";